"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminBidderComponent = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
//INTERNAL BITS
const permission_service_1 = require("./permission.service");
const notification_service_1 = require("./notification.service");
const bidder_service_1 = require("./bidder.service");
const loading_service_1 = require("./loading.service");
let AdminBidderComponent = class AdminBidderComponent {
    sortSign() {
        if (this.sortMod) {
            return '+';
        }
        else {
            return '-';
        }
    }
    constructor(_talk, _router, _cd, _bidder, _permission, _loading) {
        this._talk = _talk;
        this._router = _router;
        this._cd = _cd;
        this._bidder = _bidder;
        this._permission = _permission;
        this._loading = _loading;
        this.sortList = 'name';
        this.sortMod = true;
        this.searchTerm = '';
    }
    ngOnInit() {
        this.permission = this._permission.get();
        this.bidders = this._bidder.get().map(bidder => {
            bidder["locked"] = (bidder.lock == "null" || bidder.lock == null || bidder.lock.enabled == false) ? false : true;
            return bidder;
        });
    }
    openBidder(bidder) {
        this._loading.start("Loading Bidder...");
        this._router.navigate(['controlcenter/edit', bidder.id]);
    }
    sort(sortBy) {
        if (this.sortList == sortBy) {
            this.sortMod = !this.sortMod;
        }
        else {
            this.sortList = sortBy;
            this.sortMod = true;
        }
    }
    deleteBidder(bidder) {
        this._talk.confirm("Are you sure you want to delete this bidder file? Please note that deleting a bidder file does not deactivate that script from running on your page if it still remains there. If your Biddr360 header bidding script is still on your page, and you wish to remove it, you must remove the script from the code on your page.").then(resultPromise => {
            if (resultPromise.result)
                return resultPromise.result
                    .then(result => {
                    if (result) {
                        this._router.navigate(['/refresh']);
                        this._loading.start('Deleting Bidder...');
                        return this._bidder.delete(bidder.id).then(deleted => {
                            this._loading.stop();
                            this._router.navigate(['/controlcenter/list']);
                        });
                    }
                });
        }).catch(err => {
            console.error('unable to delete bidder', err);
        });
    }
    restoreBidder(bidder) {
        this._talk.confirm("Are you sure you want to restore this Bidder?").then(resultPromise => {
            if (resultPromise.result)
                return resultPromise.result
                    .then(result => {
                    if (result) {
                        this._router.navigate(['/refresh']);
                        this._loading.start('Restoring Bidder...');
                        return this._bidder.restore(bidder.id).then(deleted => {
                            this._loading.stop();
                            this._router.navigate(['/controlcenter/list']);
                        });
                    }
                });
        }).catch(err => {
            console.error('unable to delete bidder', err);
        });
    }
    pauseBidder(bidder) {
        if (typeof bidder.paused == 'undefined' || bidder.paused == false) {
            this._talk.confirm("Are you sure you want to pause this Bidder? Please note that by pausing this Bidder, it will automatically hit our servers so that your script stops running. To turn your script back on, simply click the play button.").then(resultPromise => {
                if (resultPromise.result)
                    return resultPromise.result
                        .then(result => {
                        if (result) {
                            this._router.navigate(['/refresh']);
                            this._loading.start('Pausing Bidder...');
                            return this._bidder.pause(bidder.id).then(res => {
                                this._loading.stop();
                                this._router.navigate(['/controlcenter/list']);
                            });
                        }
                    });
            }).catch(err => {
                console.error('unable to pause bidder', err);
            });
        }
        else {
            this._talk.confirm("Are you sure you want to turn your Bidder file back on?").then(resultPromise => {
                if (resultPromise.result)
                    return resultPromise.result
                        .then(result => {
                        if (result) {
                            this._router.navigate(['/refresh']);
                            this._loading.start('Restoring Bidder...');
                            return this._bidder.unpause(bidder.id).then(res => {
                                this._loading.stop();
                                this._router.navigate(['/controlcenter/list']);
                            });
                        }
                    });
            }).catch(err => {
                console.error('unable to unpause bidder', err);
            });
        }
    }
    copyBidder(event, bidderId) {
        event.stopPropagation();
        this._loading.start("Loading Bidder...");
        this._bidder.bidderId = bidderId;
        this._router.navigate(['controlcenter/copy']);
    }
};
exports.AdminBidderComponent = AdminBidderComponent;
exports.AdminBidderComponent = AdminBidderComponent = __decorate([
    (0, core_1.Component)({
        selector: 'admin-bidder',
        templateUrl: 'app/admin-bidder.component.html',
        styleUrls: ['styles/admin.component.css'],
    }),
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [notification_service_1.NotificationService,
        router_1.Router,
        core_1.ChangeDetectorRef,
        bidder_service_1.BidderService,
        permission_service_1.PermissionService,
        loading_service_1.LoadingService])
], AdminBidderComponent);
//# sourceMappingURL=admin-bidder.component.js.map